import { z } from 'zod/v4';

import { assetIdentifierSchema } from './asset-identifier.schema';

export const userIdentifierSchema = z.object({
  userIdentifierTypeId: z.number(),
  userIdentifierTypeName: assetIdentifierSchema,
  isDefault: z.boolean(),
});

export type UserIdentifier = z.infer<typeof userIdentifierSchema>;
